<template>
	<div class="custom-input">
		<img 
			v-if="icon"
			class="icon-input"
			:src="icon"
			@click="$emit('click')">
		<input
			class="custom-input-input"
			:value="formattedView"
			:readonly="readonly">
	</div>
</template>

<script>
function created() {
}

export default {
	name: 'PInputIcon',
	created,
	props: {
		disabled: {
			default: () => false,
		},
		maxWidth: {
			default: () => 'auto',
		},
		icon: {
			default: '',
			type: String,
		},
		showIcon: {
			default: true,
			type: Boolean,
		},
		readonly: {
			default: false,
			type: Boolean,
		},
		dataView: {
			default: {},
			type: Object,
		},
	},
	computed: {
		formattedView() {
			const quantity = this.dataView.quantity ? this.dataView.quantity : '';
			const timeName = this.dataView.time ? this.dataView.time.name : '';
			const measureTimeName = this.dataView.measureTime ? this.dataView.measureTime.name : '';
			if (quantity && timeName && measureTimeName) {
				return `${quantity} ${timeName} ${measureTimeName}`.trim();
			}
			return '';
		},
	},
	watch: {
	},
};
</script>

<style lang="scss" scoped>
.custom-input {
	display: inline-flex;
	position: relative;
  	align-items: center;
	.icon-input {
		position: absolute;
		right: 10px;
		cursor: pointer;
	}
	&-input {
		background: map-get($colors, gray-light);
		border: 1px solid map-get($colors, gray-light);
		border-radius: 6px;
        display: block;
        outline: none;
		color: map-get($colors, black-bold);
		font-family: font(bold);
		padding: 5px 10px;
		min-width: 270px;

		&::placeholder {
			color: map-get($colors, placeholder);
		}
	}

}
</style>



// WEBPACK FOOTER //
// src/modules/shared/components/ui/p-input-icon.vue